module.exports = __webpack_public_path__ + "media/images/vr/promo-catalogo-section-bg-2-m-a33ba3b68880907a62187e2e1e16a17f.jpg";